module.exports = __webpack_public_path__ + "static/media/warning.fd6f717d.svg";